export default "__VITE_ASSET__7560784b__"